class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  static overlayPositionHandler = null;

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;
    }

    super.onToggle();
    HeaderMenu.syncOverlayPositionTracking();
  }

  static updateOverlayPosition() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(header.getBoundingClientRect().bottom)}px`
    );
  }

  static syncOverlayPositionTracking() {
    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    const hasOpenMegaMenu = document.querySelector('.header details.mega-menu[open]');

    if (!isDesktop || !hasOpenMegaMenu) {
      if (this.overlayPositionHandler) {
        window.removeEventListener('scroll', this.overlayPositionHandler);
        window.removeEventListener('resize', this.overlayPositionHandler);
        this.overlayPositionHandler = null;
      }
      return;
    }

    this.updateOverlayPosition();

    if (!this.overlayPositionHandler) {
      this.overlayPositionHandler = () => this.updateOverlayPosition();
      window.addEventListener('scroll', this.overlayPositionHandler, { passive: true });
      window.addEventListener('resize', this.overlayPositionHandler, { passive: true });
    }
  }
}

customElements.define('header-menu', HeaderMenu);
